// extracted by mini-css-extract-plugin
export default {"container_btn":"Backoffice-Staff_container_btn__Zs5JM","btn":"Backoffice-Staff_btn__fcAlI","filtros":"Backoffice-Staff_filtros__NeQ--"};